/*
 * Public API Surface of ionic-perfect-iap
 */

export * from './lib/ionic-perfect-iap.service';
export * from './lib/ionic-perfect-iap.component';
export * from './lib/ionic-perfect-iap.module';
export * from './lib/interfaces/register-product-identifier.interface';
export * from './lib/stores/fake.store';
export * from './lib/stores/store.interface';
export * from './lib/stores/iap.store';
